export const APP = 'Student-Web' as const
export const PUBLIC_APP = `${APP}-Public` as const

export const FIELDS = {
  APP: 'app',
  PAGE: 'page',
  SCID: 'scid',
  CAREER_CODE: 'careerCode',
  CAREER_TITLE: 'careerTitle',
  CAROUSEL_KEY: 'carouselKey',
  CAROUSEL_ITEM_IDX: 'carouselItemIndex',
  CONTENT_TYPE: 'contentType',
  COLLEGE_CONTENT_ID: 'contentItemId',
  CONTENT_ID: 'contentId',
  CONTENT_SEARCH_TAG: 'contentSearchTag',
  COLLEGE_CONTENT_EXPANDED: 'expanded',
  DOMAIN_TYPE: 'DomainType',
  ITEM_NUMBER: 'itemNumber',
  LOCATION: 'location',
  LOCATION_INDEX: 'locationIndex',
  LOCATION_KEY: 'locationKey',
  FILTER: 'filter',
  CURRENT_URL: 'currentUrl',
  SEARCH_TERM: 'searchTerm',
  TOP_OPTIONS: 'topOptions',
  CONTENT_ITEM_WAS_TARGETED: 'contentItemWasTargeted',
  VIDEO_CONTENT: 'videoContent',
  EVENT_SEARCH_FILTERS: 'CollegeEventContentFilter',
  PROGRAM_SEARCH_FILTERS: 'ProgramContentFilter',
  SEARCH_TAG: 'SearchTag',
  PREVIOUS_URL: 'previousUrl',
  MESSAGE_ID: 'MessageId',
  ADVANCED_SEARCH_FILTERS: 'AdvancedSearchFilters',
  ADVANCED_SEARCH_SORT: 'AdvancedSearchSort',
  ADVANCED_SEARCH_NAME: 'AdvancedSearchNameQuery',
  SOURCE_CLICK_LOCATION: 'SourceClickLocation',
} as const

export const LOCATIONS = {
  SEARCH_RESULTS: 'search-results',
  CAROUSEL: 'carousel',
  HEADER: 'header',
  FOOTER: 'footer',
  SIMILAR_COLLEGES: 'similar-colleges',
  COLLEGE_PROFILE_OVERVIEW: 'college-profile-overview',
  COLLEGE_PROFILE_ACADEMICS: 'college-profile-academics',
  COLLEGE_PROFILE_ADMISSIONS: 'college-profile-admissions',
  COLLEGE_PROFILE_STUDENT_LIFE: 'college-profile-student-life',
  COLLEGE_PROFILE_COST_AID: 'college-profile-cost-aid',
  COLLEGE_PROFILE_SESSIONS: 'college-profile-sessions',
  PREFERENCE_MATCH_INDICATOR: 'preference-match-indicator',
  COLLEGE_CONTENT_SEARCH_RESULTS: 'college-content-search-results',
  NEW_POSTS: 'discover-new-posts',
  COLLEGE_EVENTS: 'discover-college-events',
  COLLEGE_PROGRAMS: 'discover-college-programs',
  COLLEGE_EVENT_SEARCH_RESULTS: 'college-events',
  COLLEGE_PROGRAMS_SEARCH_RESULTS: 'college-programs',
  ADMISSION_INTELLIGENCE: 'admission-intelligence',
  TOP_CHOICES: 'top-choices',
} as const

export const CONTENT_TYPES = {
  COLLEGE_CONTENT: 'college-content',
  COLLEGE_SESSION: 'college-session',
  COLLEGE_EVENTS: 'college-events',
  COLLEGE_PROGRAMS: 'college-programs',
  AFFILIATE_CAMPUSES: 'AffiliateCampuses',
} as const

export const PAGES = {
  DISCOVER: 'discover',
  GLOBAL_HEADER: 'global-header',
  ADVANCED_SEARCH: 'advanced-search',
  COLLEGE_COMPARE: 'college-compare',
  COLLEGE_DETAILS: 'college-details',
  COLLEGE_PROFILE: 'college-profile',
  COLLEGE_PROFILE_OVERVIEW: 'college-profile-overview',
  COLLEGE_PROFILE_ACADEMICS: 'college-profile-academics',
  COLLEGE_PROFILE_ADMISSIONS: 'college-profile-admissions',
  COLLEGE_PROFILE_STUDENT_LIFE: 'college-profile-student-life',
  COLLEGE_PROFILE_COST_AID: 'college-profile-cost-aid',
  COLLEGE_PROFILE_SESSIONS: 'college-profile-sessions',
  COLLEGE_DETAILS_OVERVIEW: 'college-details-overview',
  DASHBOARD: 'dashboard',
  MY_COLLEGES: 'my-colleges',
  PREFERENCE_SEARCH: 'preferences-search',
  MY_MATCHES: 'my-matches',
  YOU_MAY_ALSO_LIKE: 'you-may-also-like',
  CAREERS: 'careers',
  CAREERS_OVERVIEW: 'career-page-overview',
  FREE_APPS_WITH_SCOIR: 'free-apps-with-scoir',
  MESSAGES: 'messages',
  MESSAGE_MY_MATCHES: 'message-my-matches',
  COLLEGE_CONTENT_SEARCH: 'college-content-search',
  COLLEGE_EVENT_SEARCH: 'all-sessions',
  COLLEGE_EVENTS: 'college-events',
  COLLEGE_PROGRAMS: 'college-programs',
} as const
